let isMobile;
let isDesktop;

function detectDevice() {
  const $body = $("body");
  const md = new MobileDetect(window.navigator.userAgent);
  isMobile = () => {
    const device = md.mobile() || md.tablet();
    return device && device.length > 0;
  };
  isDesktop = () => !isMobile();
  if (isMobile()) {
    $body.addClass("hover-off touch-on");
    isMobile = true;
    isDesktop = false;
  } else {
    $body.addClass("hover-on touch-off");
    isDesktop = true;
    isMobile = false;
  }
}

detectDevice();

$(window).on("resize", detectDevice);
